// Growth By Ayaan - Core Interactive Logic & UX Engine

document.addEventListener('DOMContentLoaded', () => {
  initNavbar();
  initCurrencyManager();
  initCalculator();
  initPortfolioFilters();
  initCaseStudyModal();
  initServiceModal();
  initFaqAccordion();
  initContactForm();
  initToast();
});

// 1. Navigation & Scroll Spy
function initNavbar() {
  const header = document.getElementById('main-header');
  const mobileToggle = document.getElementById('mobile-toggle');
  const mobileMenu = document.getElementById('mobile-menu');
  const navLinks = document.querySelectorAll('.nav-link');
  const sections = document.querySelectorAll('section[id]');

  // Sticky header background transition
  window.addEventListener('scroll', () => {
    if (window.scrollY > 40) {
      header.classList.add('bg-[#08090b]/90', 'backdrop-blur-md', 'border-b', 'border-white/10', 'py-3');
      header.classList.remove('py-5', 'border-transparent');
    } else {
      header.classList.remove('bg-[#08090b]/90', 'backdrop-blur-md', 'border-b', 'border-white/10', 'py-3');
      header.classList.add('py-5', 'border-transparent');
    }

    // Scroll spy
    let current = '';
    const scrollPosition = window.pageYOffset + 200;

    sections.forEach(section => {
      const sectionTop = section.offsetTop;
      const sectionHeight = section.offsetHeight;
      if (scrollPosition >= sectionTop && scrollPosition < sectionTop + sectionHeight) {
        current = section.getAttribute('id');
      }
    });

    navLinks.forEach(link => {
      link.classList.remove('text-[#a3e635]', 'font-semibold');
      link.classList.add('text-gray-300');
      if (link.getAttribute('href') === `#${current}`) {
        link.classList.add('text-[#a3e635]', 'font-semibold');
        link.classList.remove('text-gray-300');
      }
    });
  });

  // Mobile menu toggle
  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener('click', () => {
      const isOpen = !mobileMenu.classList.contains('hidden');
      if (isOpen) {
        mobileMenu.classList.add('hidden');
        document.body.style.overflow = '';
      } else {
        mobileMenu.classList.remove('hidden');
        document.body.style.overflow = 'hidden';
      }
    });

    const mobileLinks = mobileMenu.querySelectorAll('a');
    mobileLinks.forEach(link => {
      link.addEventListener('click', () => {
        mobileMenu.classList.add('hidden');
        document.body.style.overflow = '';
      });
    });
  }
}

// Global Currency State ('USD' | 'PKR')
let currentCurrency = 'USD';

function setGlobalCurrency(currency) {
  currentCurrency = currency;
  localStorage.setItem('growth_currency', currency);

  // Update Navbar currency buttons
  document.querySelectorAll('.currency-btn').forEach(btn => {
    if (btn.getAttribute('data-currency') === currency) {
      btn.classList.add('bg-[#a3e635]', 'text-black', 'shadow-[0_0_12px_rgba(163,230,53,0.3)]');
      btn.classList.remove('text-gray-400');
    } else {
      btn.classList.remove('bg-[#a3e635]', 'text-black', 'shadow-[0_0_12px_rgba(163,230,53,0.3)]');
      btn.classList.add('text-gray-400');
    }
  });

  // Update Calculator currency buttons
  document.querySelectorAll('.calc-currency-btn').forEach(btn => {
    if (btn.getAttribute('data-currency') === currency) {
      btn.classList.add('bg-[#a3e635]', 'text-black', 'shadow-[0_0_12px_rgba(163,230,53,0.3)]');
      btn.classList.remove('text-gray-400', 'hover:text-white');
    } else {
      btn.classList.remove('bg-[#a3e635]', 'text-black', 'shadow-[0_0_12px_rgba(163,230,53,0.3)]');
      btn.classList.add('text-gray-400', 'hover:text-white');
    }
  });

  // Update Calculator Sliders and labels
  const budgetInput = document.getElementById('calc-budget');
  const aovInput = document.getElementById('calc-aov');
  const budgetMin = document.getElementById('calc-budget-min');
  const budgetMid = document.getElementById('calc-budget-mid');
  const budgetMax = document.getElementById('calc-budget-max');
  const aovMin = document.getElementById('calc-aov-min');
  const aovMid = document.getElementById('calc-aov-mid');
  const aovMax = document.getElementById('calc-aov-max');

  if (budgetInput && aovInput) {
    if (currency === 'PKR') {
      budgetInput.min = '50000';
      budgetInput.max = '2500000';
      budgetInput.step = '25000';
      budgetInput.value = '250000';

      aovInput.min = '2000';
      aovInput.max = '100000';
      aovInput.step = '1000';
      aovInput.value = '12000';

      if (budgetMin) budgetMin.textContent = '₨ 50,000';
      if (budgetMid) budgetMid.textContent = '₨ 1,250,000';
      if (budgetMax) budgetMax.textContent = '₨ 2,500,000';

      if (aovMin) aovMin.textContent = '₨ 2,000';
      if (aovMid) aovMid.textContent = '₨ 50,000';
      if (aovMax) aovMax.textContent = '₨ 100,000';
    } else {
      budgetInput.min = '500';
      budgetInput.max = '25000';
      budgetInput.step = '250';
      budgetInput.value = '3000';

      aovInput.min = '20';
      aovInput.max = '1000';
      aovInput.step = '10';
      aovInput.value = '120';

      if (budgetMin) budgetMin.textContent = '$500';
      if (budgetMid) budgetMid.textContent = '$12,500';
      if (budgetMax) budgetMax.textContent = '$25,000';

      if (aovMin) aovMin.textContent = '$20';
      if (aovMid) aovMid.textContent = '$500';
      if (aovMax) aovMax.textContent = '$1,000';
    }
  }

  // Update contact budget pills
  updateContactBudgetPills(currency);

  // Recalculate
  if (window.triggerCalcUpdate) {
    window.triggerCalcUpdate();
  }
}

function initCurrencyManager() {
  const saved = localStorage.getItem('growth_currency');
  if (saved && (saved === 'PKR' || saved === 'USD')) {
    currentCurrency = saved;
  }

  // Navbar currency toggle listeners
  document.querySelectorAll('.currency-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const curr = btn.getAttribute('data-currency');
      setGlobalCurrency(curr);
    });
  });

  // Calculator currency toggle listeners
  document.querySelectorAll('.calc-currency-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const curr = btn.getAttribute('data-currency');
      setGlobalCurrency(curr);
    });
  });
}

function formatPrice(amount) {
  if (currentCurrency === 'PKR') {
    return `₨ ${amount.toLocaleString('en-PK')}`;
  }
  return `$${amount.toLocaleString('en-US')}`;
}

function updateContactBudgetPills(currency) {
  const container = document.getElementById('contact-budget-container');
  const budgetInput = document.getElementById('selected-budget-input');
  if (!container) return;

  const usdOptions = [
    { label: '< $1,000', val: 'Under $1,000 USD' },
    { label: '$1,000 - $3,000', val: '$1,000 - $3,000 USD', default: true },
    { label: '$3,000 - $5,000', val: '$3,000 - $5,000 USD' },
    { label: '$5,000+', val: '$5,000+ USD' }
  ];

  const pkrOptions = [
    { label: '< ₨ 150k', val: 'Under PKR 1.5 Lakh' },
    { label: '₨ 150k - ₨ 400k', val: 'PKR 1.5L - 4L', default: true },
    { label: '₨ 400k - ₨ 10 Lakh', val: 'PKR 4L - 10L' },
    { label: '₨ 10 Lakh+', val: 'PKR 10 Lakh+' }
  ];

  const options = currency === 'PKR' ? pkrOptions : usdOptions;
  container.innerHTML = options.map(opt => `
    <button type="button" class="budget-select-pill px-3.5 py-1.5 rounded-full text-xs font-semibold border transition-all ${opt.default ? 'bg-[#a3e635] text-black border-[#a3e635]' : 'bg-[#141922] text-gray-300 border-white/10 hover:border-[#a3e635]'}" data-value="${opt.val}">${opt.label}</button>
  `).join('');

  const defaultOpt = options.find(o => o.default) || options[0];
  if (budgetInput) {
    budgetInput.value = defaultOpt.val;
  }

  container.querySelectorAll('.budget-select-pill').forEach(pill => {
    pill.addEventListener('click', () => {
      container.querySelectorAll('.budget-select-pill').forEach(p => {
        p.classList.remove('bg-[#a3e635]', 'text-black', 'border-[#a3e635]');
        p.classList.add('bg-[#141922]', 'text-gray-300', 'border-white/10');
      });
      pill.classList.add('bg-[#a3e635]', 'text-black', 'border-[#a3e635]');
      pill.classList.remove('bg-[#141922]', 'text-gray-300', 'border-white/10');
      if (budgetInput) budgetInput.value = pill.getAttribute('data-value');
    });
  });
}

// 2. Interactive ROAS & Growth Calculator
function initCalculator() {
  const budgetInput = document.getElementById('calc-budget');
  const budgetDisplay = document.getElementById('calc-budget-val');
  const aovInput = document.getElementById('calc-aov');
  const aovDisplay = document.getElementById('calc-aov-val');
  const platformSelect = document.getElementById('calc-platform');
  const resultRevenue = document.getElementById('calc-result-revenue');
  const resultRoas = document.getElementById('calc-result-roas');
  const resultLeads = document.getElementById('calc-result-leads');

  if (!budgetInput || !resultRevenue) return;

  function updateCalculations() {
    const budget = parseFloat(budgetInput.value) || (currentCurrency === 'PKR' ? 250000 : 3000);
    const aov = parseFloat(aovInput.value) || (currentCurrency === 'PKR' ? 12000 : 120);
    const platform = platformSelect ? platformSelect.value : 'omni';

    // Update displays with formatted currency
    budgetDisplay.textContent = formatPrice(budget);
    aovDisplay.textContent = formatPrice(aov);

    // Multipliers & CPA based on Ayaan's campaign benchmarks
    let multiplier = 4.1;
    let leadCpa = currentCurrency === 'PKR' ? 2500 : 26;

    if (platform === 'meta') {
      multiplier = 3.9;
      leadCpa = currentCurrency === 'PKR' ? 2200 : 24;
    } else if (platform === 'google') {
      multiplier = 4.4;
      leadCpa = currentCurrency === 'PKR' ? 3200 : 34;
    } else {
      multiplier = 4.6; // Omnichannel
      leadCpa = currentCurrency === 'PKR' ? 2500 : 26;
    }

    const estimatedRevenue = Math.round(budget * multiplier);
    const estimatedLeadsOrOrders = Math.round(budget / leadCpa);

    resultRevenue.textContent = formatPrice(estimatedRevenue);
    resultRoas.textContent = `${multiplier.toFixed(1)}x Target ROAS`;
    resultLeads.textContent = `${estimatedLeadsOrOrders.toLocaleString()}+ Qualified Leads/Orders`;
  }

  window.triggerCalcUpdate = updateCalculations;

  budgetInput.addEventListener('input', updateCalculations);
  aovInput.addEventListener('input', updateCalculations);
  if (platformSelect) {
    platformSelect.addEventListener('change', updateCalculations);
  }

  // Initial calculation
  setGlobalCurrency(currentCurrency);
}

// 3. Portfolio Filters
function initPortfolioFilters() {
  const filterBtns = document.querySelectorAll('.portfolio-filter-btn');
  const items = document.querySelectorAll('.portfolio-item');

  filterBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      // Toggle active states
      filterBtns.forEach(b => {
        b.classList.remove('bg-[#a3e635]', 'text-black', 'shadow-[0_0_15px_rgba(163,230,53,0.4)]');
        b.classList.add('bg-[#141922]', 'text-gray-300', 'border', 'border-white/10');
      });
      btn.classList.add('bg-[#a3e635]', 'text-black', 'shadow-[0_0_15px_rgba(163,230,53,0.4)]');
      btn.classList.remove('bg-[#141922]', 'text-gray-300', 'border', 'border-white/10');

      const filter = btn.getAttribute('data-filter');

      items.forEach(item => {
        const category = item.getAttribute('data-category');
        if (filter === 'all' || category.includes(filter)) {
          item.classList.remove('hidden');
          item.classList.add('animate-fadeIn');
        } else {
          item.classList.add('hidden');
        }
      });
    });
  });
}

// 4. Case Study Details Modal
const caseStudiesData = {
  'meta-ads': {
    title: 'Meta Ads Revenue Scaling ("Stop Spending, Start Investing")',
    client: 'US E-Commerce Apparel Brand (Miami, FL)',
    service: 'Performance Marketing & Meta Ads Management',
    stats: [
      { label: 'ROAS Achieved', value: '4.85x' },
      { label: 'Revenue Generated', value: '$148,000+' },
      { label: 'Cost Per Acquisition', value: '-38%' },
      { label: 'Scale Timeline', value: '60 Days' }
    ],
    overview: 'The brand was burning ad budget on boosted posts with zero retargeting architecture or conversion tracking. We restructured their entire Meta ad account into a full-funnel ecosystem.',
    deliverables: [
      'Conversion API (CAPI) and high-accuracy Meta Pixel implementation',
      'Dynamic product retargeting & lookalike audience clusters',
      'High-converting hook creatives with UGC-style video scripts',
      'Dedicated fast-loading landing page with 1-click checkout'
    ],
    quote: '"Ayaan turned our ad spend into a predictable revenue stream. Our profits nearly tripled in two months!" — Sarah J., Co-Founder'
  },
  'why-wordpress': {
    title: 'High-Performance WordPress & Elementor Pro Architecture',
    client: 'Apex Corporate Consulting (Austin, TX)',
    service: 'Business Website Development & Elementor Pro Customization',
    stats: [
      { label: 'PageSpeed Score', value: '99/100' },
      { label: 'Mobile Conversion', value: '+42%' },
      { label: 'Lead Volume', value: '3.4x' },
      { label: 'Code Cleanliness', value: '100% Semantic' }
    ],
    overview: 'Apex needed a credible, elite corporate website that could handle heavy lead gen traffic from USA enterprise clients without slowdowns or security vulnerabilities.',
    deliverables: [
      'Bespoke Elementor Pro architecture with zero theme bloat',
      'Custom Gutenberg lead capture components and CRM integration',
      'Strict asset minification and WebP media automation',
      'Enterprise SSL, Cloudflare DNS, and security hardening'
    ],
    quote: '"The site loads instantly and looks like a Fortune 500 agency built it. Outstanding work." — James Carter, CEO'
  },
  'optimize-now': {
    title: 'Core Web Vitals & Speed Optimization ("Optimize Now")',
    client: 'Luxe D2C Lifestyle Store (New York, NY)',
    service: 'Speed Revamp & Database Optimization',
    stats: [
      { label: 'Load Time Before', value: '4.9s' },
      { label: 'Load Time After', value: '0.8s' },
      { label: 'Bounce Rate', value: '-49%' },
      { label: 'Checkout Completions', value: '+31%' }
    ],
    overview: 'A sluggish WooCommerce store was losing customers at checkout due to unoptimized queries and 40+ unnecessary plugins.',
    deliverables: [
      'Purged bloated database tables and rogue cron jobs',
      'Configured server-side Redis object caching and CDN edge caching',
      'Optimized critical rendering path (LCP & CLS fix)',
      'Eliminated render-blocking JavaScript and CSS chunks'
    ],
    quote: '"Our bounce rate plummeted immediately after Ayaan optimized our website. Unbelievable speed." — Daniel S., Operations'
  },
  'local-seo': {
    title: 'US Local Search Domination ("Master Local SEO")',
    client: 'Premier Dental & Wellness Center (Dallas, TX)',
    service: 'Local SEO, High-Intent Landing Pages & Google Ads',
    stats: [
      { label: 'Google Map Pack Rank', value: '#1 in City' },
      { label: 'Inbound Calls/Month', value: '185+' },
      { label: 'Organic Traffic', value: '+210%' },
      { label: 'Cost Per Booking', value: '$19.50' }
    ],
    overview: 'Local practice struggling to get found on Google against established multi-location clinics in Dallas.',
    deliverables: [
      'Complete Google Business Profile overhaul and local schema injection',
      'Geo-targeted high-conversion WordPress service landing pages',
      'NAP consistency audit and local citation syndication',
      'Click-to-call mobile lead optimization and appointment booking integration'
    ],
    quote: '"We are now booked out two weeks in advance thanks to the local Google ranking." — Dr. M. Harris, Practice Lead'
  },
  'google-meta': {
    title: 'Cross-Channel Acquisition: Google Ads vs Meta Ads Funnel',
    client: 'FinTech SaaS Platform (San Francisco, CA)',
    service: 'Multi-Channel Performance Marketing',
    stats: [
      { label: 'Monthly Pipeline', value: '$320,000' },
      { label: 'Search Intent ROAS', value: '5.2x' },
      { label: 'Social Retargeting ROAS', value: '4.1x' },
      { label: 'Blended CAC', value: '-32%' }
    ],
    overview: 'Combining the bottom-of-funnel high purchase intent of Google Search with top-of-funnel viral reach on Meta Ads.',
    deliverables: [
      'High-intent exact match keyword targeting on Google Ads Search',
      'Negative keyword lists eliminating wasted click spend',
      'Meta video ads targeting past search visitors with client testimonials',
      'Automated daily bid adjustments and ROAS scaling schedule'
    ],
    quote: '"Ayaan understands the mathematics of paid advertising better than most agencies charging 5x his rate." — Marcus Vance, CMO'
  },
  'ecommerce-store': {
    title: 'High-Converting WooCommerce Storefront & 1-Click Checkout',
    client: 'Artisan Home Decor (Los Angeles, CA)',
    service: 'WooCommerce Architecture & CRO',
    stats: [
      { label: 'Cart Abandonment', value: '-35%' },
      { label: 'Average Order Value', value: '+$34' },
      { label: 'Monthly Gross Sales', value: '$95,000+' },
      { label: 'Mobile Checkout Speed', value: '< 2 Steps' }
    ],
    overview: 'Re-engineering a sluggish custom shop into a conversion machine optimized for mobile shoppers with Apple Pay and Stripe.',
    deliverables: [
      'Custom headless-feel WooCommerce theme with instant live search',
      'Frictionless slide-out cart with upsell and cross-sell triggers',
      'Automated abandoned checkout recovery email sequences',
      'Flawless inventory sync and automated order fulfillment webhooks'
    ],
    quote: '"The checkout experience is so smooth our conversion rate jumped from 1.6% to 3.8%." — Elena Rossi, Founder'
  }
};

function initCaseStudyModal() {
  const modal = document.getElementById('case-study-modal');
  const closeBtn = document.getElementById('close-case-modal');
  const triggerBtns = document.querySelectorAll('.open-case-study');

  if (!modal) return;

  triggerBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const id = btn.getAttribute('data-case-id');
      const data = caseStudiesData[id];
      if (!data) return;

      document.getElementById('modal-case-title').textContent = data.title;
      document.getElementById('modal-case-client').textContent = data.client;
      document.getElementById('modal-case-service').textContent = data.service;
      document.getElementById('modal-case-overview').textContent = data.overview;
      document.getElementById('modal-case-quote').textContent = data.quote;

      // Stats
      const statsContainer = document.getElementById('modal-case-stats');
      statsContainer.innerHTML = data.stats.map(s => `
        <div class="bg-[#141922] p-4 rounded-xl border border-white/5 text-center">
          <div class="text-2xl font-bold font-display text-[#a3e635]">${s.value}</div>
          <div class="text-xs text-gray-400 mt-1 uppercase tracking-wider">${s.label}</div>
        </div>
      `).join('');

      // Deliverables
      const deliverContainer = document.getElementById('modal-case-deliverables');
      deliverContainer.innerHTML = data.deliverables.map(d => `
        <li class="flex items-start gap-2.5 text-sm text-gray-300">
          <span class="text-[#a3e635] font-bold text-base mt-[-2px]">✓</span>
          <span>${d}</span>
        </li>
      `).join('');

      modal.classList.remove('hidden');
      document.body.style.overflow = 'hidden';
    });
  });

  function closeModal() {
    modal.classList.add('hidden');
    document.body.style.overflow = '';
  }

  if (closeBtn) closeBtn.addEventListener('click', closeModal);
  modal.addEventListener('click', (e) => {
    if (e.target === modal) closeModal();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !modal.classList.contains('hidden')) {
      closeModal();
    }
  });
}

// 5. Service Details Modal
const servicesData = {
  'seo': {
    title: 'SEO & Organic Growth',
    tagline: 'Rank Higher on Google and Turn Searches into Qualified Leads',
    timeline: 'Audit & Setup in 7-10 Days, Ranking Growth Over 3-6 Months',
    idealFor: 'Local businesses, service providers, e-commerce stores & startups that want steady organic leads',
    deliverables: [
      'Full technical SEO audit covering crawlability, indexing, speed and mobile usability',
      'Keyword research mapped to buyer intent and your target locations',
      'On-page optimization of titles, meta descriptions, headings and internal links',
      'Local SEO setup including Google Business Profile and local citations',
      'Content and page recommendations to close gaps against your competitors',
      'Monthly ranking and traffic reports in plain language with clear next steps'
    ]
  },
  'social-media': {
    title: 'Social Media Marketing',
    tagline: 'Grow an Engaged Audience and Turn Followers into Customers',
    timeline: 'Strategy & Setup in 5-7 Days, Growth Over 2-3 Months',
    idealFor: 'Local businesses, e-commerce brands, service providers & startups that want a strong Facebook and Instagram presence',
    deliverables: [
      'Content strategy and a monthly posting calendar built around your audience and offers',
      'Facebook and Instagram page setup, optimization and steady growth',
      'Reels, post and story creatives designed to stop the scroll',
      'Community management with replies to comments and messages',
      'Linking organic content with Meta Ads to retarget engaged followers',
      'Monthly performance reports on reach, engagement and leads with clear next steps'
    ]
  },
  'meta-google-ads': {
    title: 'Meta & Google Ads Campaign Management',
    tagline: 'High ROAS & Lead Generation Engineered for US Businesses',
    timeline: 'Campaign Launch in 5-7 Days',
    idealFor: 'E-commerce brands, local service contractors, B2B agencies & startups',
    deliverables: [
      'In-depth competitor ad analysis and keyword purchase-intent mapping',
      'Meta Pixel + Conversion API (CAPI) server-side setup for iOS 14+ tracking',
      'Google Ads Search, Performance Max & Retargeting campaign architecture',
      'High-converting ad copywriting and creative direction (video/image)',
      'Custom negative keyword curation to eliminate wasted ad spend',
      'Weekly transparent performance reports with live ROAS and CPA metrics'
    ]
  },
  'business-website': {
    title: 'Business Website Development',
    tagline: 'High-Performance WordPress & Elementor Pro Sites Built to Convert',
    timeline: 'Turnaround in 7-14 Days',
    idealFor: 'Small businesses, US startups, consultants & service companies',
    deliverables: [
      'Custom bespoke Elementor Pro layout tailored strictly to your brand',
      'Mobile-first responsive architecture tested across all screen resolutions',
      'On-page SEO setup (meta tags, semantic hierarchy, Open Graph, sitemaps)',
      'High-converting lead generation forms connected to your email or CRM',
      'Clean, maintainable architecture with zero bloated third-party plugins',
      'Comprehensive 1-on-1 video walkthrough showing you how to update content'
    ]
  },
  'ecommerce-development': {
    title: 'E-commerce Store Development',
    tagline: 'WooCommerce Storefronts Optimized for Smooth Checkouts and Revenue',
    timeline: 'Turnaround in 10-18 Days',
    idealFor: 'Direct-to-consumer (D2C) brands, retailers & digital product creators',
    deliverables: [
      'Frictionless slide-out cart & 1-page checkout to eliminate abandonment',
      'Payment gateway integrations: Stripe, PayPal, Apple Pay, Google Pay',
      'Automated shipping calculation, tax zones, and inventory tracking',
      'Smart product recommendations, upselling triggers, and bundle offers',
      'Automated email sequences for abandoned carts and order notifications',
      'Sub-second page loading speed for high conversion retention'
    ]
  },
  'wp-fixing': {
    title: 'WordPress Fixing & Bug Repair',
    tagline: 'Fast Debugging, Layout Fixes & Stability Restoration',
    timeline: 'Same-Day / 24-48 Hour Emergency Turnaround',
    idealFor: 'Site owners facing broken layouts, fatal errors, or plugin conflicts',
    deliverables: [
      'Resolution of White Screen of Death (WSoD) and 500 internal server errors',
      'Fixing broken Elementor layouts, CSS stylesheet bugs, and responsive glitches',
      'Resolving PHP incompatibilities and plugin/theme version collisions',
      'Database repair, malicious script removal, and malware cleanups',
      'Form submission troubleshooting and SMTP email delivery repair',
      'Full post-repair backup and stability health report'
    ]
  },
  'website-redesign': {
    title: 'Website Redesign & Speed Optimization',
    tagline: 'Revamping Outdated Sites Into High-Speed Conversion Engines',
    timeline: 'Turnaround in 7-12 Days',
    idealFor: 'Established businesses with slow, outdated, or low-converting sites',
    deliverables: [
      'Modern, premium visual redesign tailored for 2026 conversion expectations',
      'Zero-loss content and SEO ranking preservation (301 redirects & URL integrity)',
      'Core Web Vitals overhaul: Achieving 90+ PageSpeed on Mobile & Desktop',
      'Server-level caching setup, WebP image automation, and CSS/JS minification',
      'Redesigned user flows reducing bounce rate and boosting inquiry submissions',
      'Comprehensive before-and-after speed & performance audit'
    ]
  },
  'wp-migration': {
    title: 'WordPress Migration & Setup',
    tagline: 'Secure, Zero-Downtime Hosting Transfers & DNS Configuration',
    timeline: 'Same-Day / 24-Hour Execution',
    idealFor: 'Brands switching hosts, upgrading servers, or changing domains',
    deliverables: [
      '100% zero-downtime server-to-server migration with zero data loss',
      'Complete transfer of files, media library, databases, and user accounts',
      'DNS records reconfiguration (A records, MX records, CNAME, SPF/DKIM)',
      'Free SSL certificate installation and HTTPS redirection enforcement',
      'Email accounts and business webmail transfer verification',
      'Post-migration testing of all forms, checkouts, and dynamic functions'
    ]
  }
};

function initServiceModal() {
  const modal = document.getElementById('service-modal');
  const closeBtn = document.getElementById('close-service-modal');
  const triggerBtns = document.querySelectorAll('.open-service-modal');

  if (!modal) return;

  triggerBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const id = btn.getAttribute('data-service-id');
      const data = servicesData[id];
      if (!data) return;

      document.getElementById('service-modal-title').textContent = data.title;
      document.getElementById('service-modal-tagline').textContent = data.tagline;
      document.getElementById('service-modal-timeline').textContent = data.timeline;
      document.getElementById('service-modal-ideal').textContent = data.idealFor;

      const listContainer = document.getElementById('service-modal-deliverables');
      listContainer.innerHTML = data.deliverables.map(item => `
        <li class="flex items-start gap-2.5 text-sm text-gray-300">
          <span class="text-[#a3e635] font-bold text-base mt-[-2px]">✦</span>
          <span>${item}</span>
        </li>
      `).join('');

      modal.classList.remove('hidden');
      document.body.style.overflow = 'hidden';
    });
  });

  function closeModal() {
    modal.classList.add('hidden');
    document.body.style.overflow = '';
  }

  if (closeBtn) closeBtn.addEventListener('click', closeModal);
  modal.addEventListener('click', (e) => {
    if (e.target === modal) closeModal();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !modal.classList.contains('hidden')) {
      closeModal();
    }
  });
}

// 6. FAQ Accordion
function initFaqAccordion() {
  const items = document.querySelectorAll('.faq-item');

  items.forEach(item => {
    const header = item.querySelector('.faq-header');
    const content = item.querySelector('.faq-content');
    const icon = item.querySelector('.faq-icon');

    if (!header || !content) return;

    header.addEventListener('click', () => {
      const isOpen = !content.classList.contains('hidden');

      // Close all other items
      items.forEach(otherItem => {
        const otherContent = otherItem.querySelector('.faq-content');
        const otherIcon = otherItem.querySelector('.faq-icon');
        const otherHeader = otherItem.querySelector('.faq-header');
        if (otherContent) otherContent.classList.add('hidden');
        if (otherIcon) {
          otherIcon.classList.remove('rotate-180', 'text-[#a3e635]');
          otherIcon.classList.add('text-gray-400');
        }
        if (otherHeader) otherHeader.classList.remove('text-[#a3e635]');
      });

      if (!isOpen) {
        content.classList.remove('hidden');
        if (icon) {
          icon.classList.add('rotate-180', 'text-[#a3e635]');
          icon.classList.remove('text-gray-400');
        }
        header.classList.add('text-[#a3e635]');
      }
    });
  });
}

// 7. Interactive Contact Form with Validation & Feedback
function initContactForm() {
  const form = document.getElementById('contact-form');
  const servicePills = document.querySelectorAll('.service-select-pill');
  const serviceInput = document.getElementById('selected-service-input');
  const budgetPills = document.querySelectorAll('.budget-select-pill');
  const budgetInput = document.getElementById('selected-budget-input');
  const submitBtn = document.getElementById('form-submit-btn');
  const formSuccess = document.getElementById('form-success-banner');

  // Service pills selection
  servicePills.forEach(pill => {
    pill.addEventListener('click', () => {
      servicePills.forEach(p => {
        p.classList.remove('bg-[#a3e635]', 'text-black', 'border-[#a3e635]');
        p.classList.add('bg-[#141922]', 'text-gray-300', 'border-white/10');
      });
      pill.classList.add('bg-[#a3e635]', 'text-black', 'border-[#a3e635]');
      pill.classList.remove('bg-[#141922]', 'text-gray-300', 'border-white/10');
      if (serviceInput) serviceInput.value = pill.getAttribute('data-value');
    });
  });

  // Budget pills selection
  budgetPills.forEach(pill => {
    pill.addEventListener('click', () => {
      budgetPills.forEach(p => {
        p.classList.remove('bg-[#a3e635]', 'text-black', 'border-[#a3e635]');
        p.classList.add('bg-[#141922]', 'text-gray-300', 'border-white/10');
      });
      pill.classList.add('bg-[#a3e635]', 'text-black', 'border-[#a3e635]');
      pill.classList.remove('bg-[#141922]', 'text-gray-300', 'border-white/10');
      if (budgetInput) budgetInput.value = pill.getAttribute('data-value');
    });
  });

  if (!form) return;

  form.addEventListener('submit', (e) => {
    e.preventDefault();

    const name = document.getElementById('contact-name').value.trim();
    const email = document.getElementById('contact-email').value.trim();
    const message = document.getElementById('contact-message').value.trim();

    if (!name || !email || !message) {
      showToast('Please fill out all required fields.', 'error');
      return;
    }

    // Email regex check
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(email)) {
      showToast('Please enter a valid business email address.', 'error');
      return;
    }

    // Submit animation
    submitBtn.disabled = true;
    const originalText = submitBtn.innerHTML;
    submitBtn.innerHTML = `
      <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-black inline-block" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
      Opening WhatsApp...
    `;

    // Open WhatsApp with the form details prefilled
    const getVal = (id) => (document.getElementById(id) || {}).value || '';
    const waMessage = `Hi Ayaan! I found you via your website.\n\n*Name:* ${name}\n*Email:* ${email}\n*Target Market / Currency:* ${currentCurrency === 'PKR' ? 'Pakistan (PKR)' : 'International / USA (USD)'}\n*Service:* ${getVal('selected-service-input')}\n*Budget:* ${getVal('selected-budget-input')}\n\n*Project Details:*\n${message}`;
    const waUrl = 'https://wa.me/923277250101?text=' + encodeURIComponent(waMessage);
    window.open(waUrl, '_blank') || (location.href = waUrl);
    setTimeout(() => {
      submitBtn.disabled = false;
      submitBtn.innerHTML = originalText;
      form.reset();
      if (formSuccess) {
        formSuccess.classList.remove('hidden');
        formSuccess.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
      showToast('WhatsApp opened! Your message is ready, just press Send.', 'success');
    }, 1200);
  });
}

// 8. Toast Feedback & Copy Email
let toastTimeout;
function showToast(message, type = 'info') {
  const toast = document.getElementById('global-toast');
  const toastMessage = document.getElementById('toast-message');
  if (!toast || !toastMessage) return;

  toastMessage.textContent = message;
  toast.classList.remove('hidden', 'translate-y-10', 'opacity-0');
  toast.classList.add('translate-y-0', 'opacity-100');

  clearTimeout(toastTimeout);
  toastTimeout = setTimeout(() => {
    toast.classList.add('translate-y-10', 'opacity-0');
    setTimeout(() => toast.classList.add('hidden'), 300);
  }, 4000);
}

function initToast() {
  const copyButtons = document.querySelectorAll('.copy-email-btn');
  copyButtons.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const email = 'business@ayaanit.com';
      navigator.clipboard.writeText(email).then(() => {
        showToast('Email copied to clipboard: business@ayaanit.com', 'success');
      }).catch(() => {
        showToast('Direct email: business@ayaanit.com', 'info');
      });
    });
  });
}
